package com.veldekar.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.veldekar.toSitePalette
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Footer as HtmlFooter

val FooterStyle = CssStyle.base {
    Modifier
        .backgroundColor(colorMode.toSitePalette().nearBackground)
        .padding(topBottom = 1.5.cssRem, leftRight = 10.percent)
        .textAlign(Center)
}

@Composable
@Suppress("MaxLineLength")
fun Footer(modifier: Modifier = Modifier, includeSrdAttribution: Boolean = false) {
    HtmlFooter(FooterStyle.toModifier().then(modifier).toAttrs()) {
        SpanText("Veldekar is a fantasy world created by Shan.")
        if (includeSrdAttribution) {
            val attrModifier = Modifier.fontSize(0.7.cssRem).opacity(0.8)
            org.jetbrains.compose.web.dom.Br()
            SpanText("This work includes material taken from the System Reference Document 5.1 (“SRD 5.1”) by Wizards of the Coast LLC and available at ", attrModifier)
            Link("https://dnd.wizards.com/resources/systems-reference-document", "https://dnd.wizards.com/resources/systems-reference-document", attrModifier)
            SpanText(". The SRD 5.1 is licensed under the Creative Commons Attribution 4.0 International License available at ", attrModifier)
            Link("https://creativecommons.org/licenses/by/4.0/legalcode", "https://creativecommons.org/licenses/by/4.0/legalcode", attrModifier)
            SpanText(".", attrModifier)
        }
    }
}
